import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserInfoService } from '../../spartacus/services/user-info.service';

@Component({
    selector: 'app-customtab',
    templateUrl: './customtab.component.html',
    styleUrls: ['./customtab.component.scss'],
    standalone: false
})
export class CustomtabComponent implements OnInit, OnDestroy {
  enablePage= {
    usertab: true,
    account: false,
    permissionadmin: false,
   
  }

  constructor(  private userInfoService: UserInfoService) {
  }
  ngOnInit() {
   
    //this.userInfoService.settabdata(obj);
    //this.userInfoService.gettabdata().subscribe((data: any) => {
      //this.enablePage = data;
      const body=<HTMLElement>document.querySelector("body");
      body.classList.add("myprofileUK")
      // Clear any stale tab classes left on <body> from a previous visit
      body.classList.remove("useratabactive");
      body.classList.remove("accounttabactive");
      body.classList.remove("permissionadminactive");
      if(this.enablePage){
      if(this.enablePage.usertab){
        body.classList.add("useratabactive");
      }
      else if(this.enablePage.account){
        body.classList.add("accounttabactive");
       
      }
      else if(this.enablePage.permissionadmin){
        body.classList.add("permissionadminactive"); 
      }
    }else{
      body.classList.add("useratabactive");
    }

  }
  tabclick(tab:string){
    const body=<HTMLElement>document.querySelector("body");
   if(tab=='user'){
    body.classList.add("useratabactive");
    body.classList.remove("accounttabactive");
    body.classList.remove("permissionadminactive");
    this.enablePage= {
      usertab: true,
      account: false,
      permissionadmin: false,
     
    }
   }
   else if(tab=='account'){
    body.classList.add("accounttabactive");
    body.classList.remove("useratabactive");
    body.classList.remove("permissionadminactive");
    this.enablePage= {
      usertab: false,
      account: true,
      permissionadmin: false,
     
    }
  }
    else if(tab=='rba'){
      body.classList.add("permissionadminactive"); 
      body.classList.remove("accounttabactive");
    body.classList.remove("useratabactive");
    this.enablePage= {
      usertab: false,
      account: false,
      permissionadmin: true,
     
    }
    }


   }

  ngOnDestroy() {
    // Remove the profile/tab classes when leaving the page so they don't
    // persist on <body> across route changes and leak into the next visit.
    const body=<HTMLElement>document.querySelector("body");
    body.classList.remove("myprofileUK");
    body.classList.remove("useratabactive");
    body.classList.remove("accounttabactive");
    body.classList.remove("permissionadminactive");
  }


}
